import {showSnackbar, SnackbarType} from 'webapp-lib/Functions';

import {CasusReadonlyReason} from '@lexian/api/invoicing-api';
import i18n from '_/i18n';

const CasusReadonlyReasonTranslation: Record<CasusReadonlyReason, string> = {
  LOCKED: i18n.t('casus:casusLocked.explicitly'),
  ARCHIVED: i18n.t('casus:casusLocked.archived'),
};

export function showCasusReadonlyWarningSnackbar(
  readonlyReason: CasusReadonlyReason
): void {
  showSnackbar({
    text: CasusReadonlyReasonTranslation[readonlyReason],
    type: SnackbarType.WARNING,
    override: {
      id: 'CasusLockedCondition',
      mode: 'REPLACE',
    },
  });
}

export function getCasusReadonlyReasonText(
  casusReadonlyReason: CasusReadonlyReason | undefined
): string | undefined {
  if (!casusReadonlyReason) {
    return undefined;
  }

  return CasusReadonlyReasonTranslation[casusReadonlyReason];
}
